import React from 'react';
import { PromptCardRedesign } from '@ai-platform/utils';

import { useExperimentFlag } from '../../contexts/ExperimentsContext';

import { PromptCard as PromptCardBase } from './PromptCard';
import { PromptCard as PromptCardNew } from './experiments/new';
import { PromptCardProps } from './PromptCard.types';

/**
 * Компонент-обертка для выбора между различными версиями PromptCard
 * В зависимости от условий возвращает либо базовую версию, либо экспериментальную
 */
export const PromptCard: React.FC<PromptCardProps> = props => {
    const { fromFeed, fromCollection, fromPopular } = props;

    const experimentFlag = useExperimentFlag('promptCardRedesign');
    const isLocationForNewDesign = fromFeed || fromCollection || fromPopular;

    if (experimentFlag === PromptCardRedesign.New && isLocationForNewDesign) {
        // Включаем новый дизайн карточек только на главной ленте, в подборках и секции топа
        return React.createElement(PromptCardNew, props);
    }

    return React.createElement(PromptCardBase, props);
};
